import React, { use, useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button, Table, Row, Col, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { receiptNoteActions } from '../../sagas/receiptNoteSlice';
import Swal from 'sweetalert2';
import { formatPrice } from '../../helpers/utility';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { components } from 'react-select';
import { supplierActions } from '../../sagas/supplierSlice';
import { FaBuilding, FaBusinessTime, FaEnvelope, FaIdCard, FaMapMarkerAlt, FaMoneyBillWave, FaPhone, FaPlus, FaUser } from 'react-icons/fa';
import ReceptionLines from './ReceptionLines';
import { data } from 'react-router-dom';
import { entrepotActions } from '../../sagas/entrepotSlice';
import { purchaseActions } from '../../sagas/purchaseSlice';
import { transporteurActions } from '../../sagas/transporteurSlice';

const ReceiptNoteNew = ({ onClose, reception }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [showSupplierModal, setShowSupplierModal] = useState(false);
    const { company } = useSelector(statut => statut.auth);
    const { purchases, loading } = useSelector((state) => state.purchases);
    const { suppliers, loading: suppliersLoading } = useSelector(state => state.suppliers);
    const [errors, setErrors] = useState({});
    const { transporteurs } = useSelector(state => state.transporteurs);

    const [filters, setFilters] = useState({
        fournisseurId: null,
        dateFrom: null,
        dateTo: null,
        query: ''
    });

    const villesMaroc = [
        'Casablanca', 'Rabat', 'Khouribga', 'Marrakech', 'Fès', 'Tanger',
        'Agadir', 'Meknès', 'Oujda', 'Kénitra', 'Tétouan',
        'Safi', 'Mohammedia', 'El Jadida', 'Nador', 'Beni Mellal'
    ];

    const [fournisseur, setFournisseur] = useState({
        nom: '',
        prenom: '',
        cin: '',
        telephone1: '',
        telephone2: '',
        email: '',
        adresse: '',
        ville: 'Casablanca',
        typeFournisseur: 'PARTICULIER',
        codePostal: '',
        plafond: 0,
        entreprise: '', // New field for "Entreprise"
        ice: '',// New field for "ICE",
        active: true,
        solde: 0 // Ce champ sera en lecture seule
    });
    const { entrepots } = useSelector(state => state.entrepots);


    useEffect(() => {
        let payload = {
            ...filters,
        };

        dispatch(purchaseActions.search(payload));

        dispatch(supplierActions.search({
            query: ""
        }));
        dispatch(transporteurActions.list());

    }, []);

    useEffect(() => {
    }, [suppliers, purchases])


    const fournisseurOptions = suppliers?.map(sup => ({
        solde: sup.solde,
        totalDebit: sup.totalDebit,
        totalCredit: sup.totalCredit,
        value: sup.id,
        label: sup.typeFournisseur === 'PARTICULIER' ? `${sup.nom} ${sup.prenom} (${sup.code})` : `${sup.entreprise}(${sup.code})`,
    })) ?? [];

    const poOptions = !loading ? purchases?.map(po => ({
        fournisseurId: po.fournisseurId,
        fournisseurNom: po.fournisseurNom,
        numeroCheque: po.numeroCheque,
        lignes: po.lignes,
        montantTotalHT: po.montantTotalHT,
        montantTotalTTC: po.montantTotalTTC,
        montantTotalTaxe: po.montantTotalTaxe,
        modeReglement: po.modeReglement,
        commandeId: po.id,
        value: po.numero,
        label: `${po.numero} - ${po.fournisseurNom}`
    })) : [];

    const formik = useFormik({
        initialValues: {
            fournisseurId: reception?.fournisseurId || null,
            fournisseurNom: reception?.fournisseurNom || '',
            deliveryNoteNb: reception?.deliveryNoteNb || '',
            dateReception: reception?.dateReception || new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0],
            dateOperation: reception?.dateOperation || new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().split('T')[0],
            lignes: reception?.lignes || [],
            montantTotalHT: reception?.montantTotalHT || 0,
            montantTotalTTC: reception?.montantTotalTTC || 0,
            montantTotalTaxe: reception?.montantTotalTaxe || 0,
            statut: reception?.statut || 'EN_ATTENTE',
            modeReglement: reception?.modeReglement || 'ESPECES',
            numeroCheque: reception?.numeroCheque,
            addresseLivraison: reception?.addresseLivraison || company.adresse,
            entrepotId: reception?.entrepotId || null,
            commandeNumero: reception?.commandeNumero || '',
            commandeId: reception?.commandeId || null,
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            fournisseurId: Yup.number().required(t('reception.supplierMissing', 'Supplier is required')),
            deliveryNoteNb: Yup.string().required(t('reception.deliveryNoteMissing', 'Delivery note number is required')),
            lignes: Yup.array().of(
                Yup.object().shape({
                    id: Yup.number(),
                    // prixUnitaireHT: Yup.number()
                    //     .min(1, t('reception.unitPriceMinValue', 'Unit price must be at least 1'))
                    //     .required(t('reception.unitPriceMissing', 'Unit price is required')),
                    quantiteRecue: Yup.number()
                        .min(1, t('reception.receivedQuantityMinValue', 'Received quantity must be at least 1'))
                        .required(t('reception.receivedQuantityMissing', 'Received quantity is required')),
                })
            ).min(1, t('reception.atLeastOneLine', 'At least one line is required')),
            entrepotId: Yup.number().required(t('reception.entrepotMissing', 'Entrepot is required')),
        }),


        onSubmit: (values) => {

            if (!values.deliveryNoteNb) {
                Swal.fire({
                    icon: 'warning',
                    title: t('reception.missingDeliveryNoteTitle', 'Missing Delivery Note Number'),
                    text: t('reception.missingDeliveryNoteMessage', 'Please enter a delivery note number before submitting.'),
                    confirmButtonText: t('common.ok', 'OK')
                });
                return; // Stop the submission process
            }

            Swal.fire({
                title: t('purchase.confirmation'),
                text: t('purchase.saveOrConfirmText'),
                icon: 'question',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: t('common.saveAndConfirm'),
                denyButtonText: t('common.save'),
                cancelButtonText: t('common.cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    values.statut = 'VALIDE';
                    values.updatedAt = null;
                    values.createdAt = null;
                    const payload = {
                        data: values,
                        onSuccess: () => {
                            Swal.fire({
                                icon: 'success',
                                title: t('common.saved'),
                                text: t('purchase.savedSuccess'),
                            });
                            onClose();
                        },
                        onError: (error) => {
                            Swal.fire(
                                t('common.error'),
                                t('reception.saveError'),
                                'error'
                            );
                        }
                    };

                    if (reception) {
                        dispatch(receiptNoteActions.updateReceiptNote({ ...payload, id: reception.id }));
                    } else {
                        dispatch(receiptNoteActions.createReceiptNote(payload));
                    }
                } else if (result.isDenied) {
                    values.statut = 'EN_ATTENTE';
                    values.updatedAt = null;
                    values.createdAt = null;
                    const payload = {
                        data: values,
                        onSuccess: () => {
                            Swal.fire({
                                icon: 'success',
                                title: t('common.saved'),
                                text: t('purchase.savedSuccess'),
                            });
                            onClose();
                        },
                        onError: (error) => {
                            Swal.fire(
                                t('common.error'),
                                t('reception.saveError'),
                                'error'
                            );
                        }
                    };

                    if (reception) {
                        dispatch(receiptNoteActions.updateReceiptNote({ ...payload, id: reception.id }));
                    } else {
                        dispatch(receiptNoteActions.createReceiptNote(payload));
                    }
                }
            });
        },
    });

    const { values, touched, getFieldProps, handleSubmit, setFieldValue } = formik;


    const handlePurchaseOrderChange = (selectedOption) => {
        console.log(selectedOption)
        if (selectedOption) {
            setFieldValue('commandeId', selectedOption.commandeId);
            setFieldValue('commandeNumero', selectedOption.value);
            setFieldValue('fournisseurId', selectedOption.fournisseurId);
            setFieldValue('fournisseurNom', selectedOption.fournisseurNom);
            setFieldValue('lignes', selectedOption.lignes.map(line => ({
                articleId: line.articleId,
                articleNom: line.articleNom,
                quantiteCommandee: line.quantiteCommandee,
                quantiteRecue: line.quantiteCommandee,
                prixUnitaireHT: line.prixUnitaireHT,
                prixUnitaireTTC: line.prixUnitaireTTC,
                montantHT: line.montantHT,
                tauxTVA: line.tauxTVA,
                unite: line.unite,
                montantTTC: line.montantTTC
            })));

            setFieldValue('montantTotalHT', selectedOption.montantTotalHT);
            setFieldValue('montantTotalTTC', selectedOption.montantTotalTTC);
            setFieldValue('montantTotalTaxe', selectedOption.montantTotalTaxe);
            setFieldValue('transporteurId', selectedOption.transporteurId);
            setFieldValue('numeroCheque', selectedOption.numeroCheque);
            setFieldValue('modeReglement', selectedOption.modeReglement);
        } else {
            setFieldValue('montantTotalHT', 0);
            setFieldValue('montantTotalTTC', 0);
            setFieldValue('montantTotalTaxe', 0);

            setFieldValue('commandeId', null);
            setFieldValue('commandeNumero', '');
            setFieldValue('fournisseurId', null);
            setFieldValue('transporteurId', null);
            setFieldValue('numeroCheque', null);
            setFieldValue('modeReglement', null);
            setFieldValue('fournisseurNom', '');
            setFieldValue('lignes', []);
        }

    };

    const handleSupplierSubmit = () => {
        const newErrors = {};
        // Common validations
        if (!fournisseur.telephone1) newErrors.telephone1 = 'Téléphone obligatoire';
        if (!fournisseur.adresse) newErrors.adresse = 'Adresse obligatoire';

        // Validations for "PARTICULIER"
        if (fournisseur.typeFournisseur === 'PARTICULIER') {
            if (!fournisseur.nom) newErrors.nom = 'Nom obligatoire';
            if (!fournisseur.prenom) newErrors.prenom = 'Prénom obligatoire';
        }

        // Validations for "ENTREPRISE"
        if (fournisseur.typeFournisseur === 'ENTREPRISE') {
            if (!fournisseur.entreprise) newErrors.entreprise = 'Nom de l\'entreprise obligatoire';
            if (!fournisseur.ice) newErrors.ice = 'Numéro ICE obligatoire';
        }


        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        let payload = {
            data: {
                ...fournisseur,
            },

            onSuccess: () => {
                Swal.fire({
                    icon: 'success',
                    title: 'Succès',
                    text: 'Client enregistrés avec succès!',
                    confirmButtonText: 'OK',
                });

                setFournisseur({
                    nom: '',
                    prenom: '',
                    cin: '',
                    telephone1: '',
                    telephone2: '',
                    typeFournisseur: 'PARTICULIER',
                    email: '',
                    adresse: '',
                    ville: 'Casablanca',
                    codePostal: '',
                    plafond: 0,
                    entreprise: '',
                    ice: '',
                    solde: 0,
                    active: true,
                });

                setShowSupplierModal(false);
                setErrors({});
            },
        };


        dispatch(supplierActions.addSupplier(payload));

    };


    const handleFournisseurChange = (e) => {
        const { name, value } = e.target;
        setFournisseur((prev) => ({
            ...prev,
            [name]: name === 'active' ? value === 'true' : value, // Convert "true"/"false" to boolean for the active field
        }));
    };

    useEffect(() => {
        dispatch(entrepotActions.list());
    }, []);

    const handleCreateSupplier = () => {
        setShowSupplierModal(true);
    };

    const handleSupplierChange = (selectedOption) => {
        formik.setFieldValue('lignes', []); // Clear the lignes when the supplier changes
        formik.setFieldValue('fournisseurId', selectedOption?.value || null);
        formik.setFieldValue('fournisseurNom', selectedOption?.label || '');
        formik.setFieldValue('montantTotalTTC', 0);
        formik.setFieldValue('montantTotalHT', 0);
        formik.setFieldValue('montantTotalTaxe', 0);
    };




    const entrepotOptions = entrepots?.map(entrepot => ({
        value: entrepot.id,
        label: entrepot.code + ' - ' + entrepot.libelle,
    })) ?? [];



    return (<>
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col md="3">
                    {reception ? <FormGroup>
                        <Label>{t('reception.originalCommande')}</Label>
                        <Input
                            type="text"
                            name="commandeNumero"
                            {...getFieldProps('commandeNumero')}
                            disabled
                        />
                    </FormGroup> : <FormGroup>
                        <Label>{t('reception.originalCommande')}</Label>
                        <Select
                            id="commandeNumero"
                            name="commandeNumero"
                            isClearable
                            placeholder={t('reception.selectOrder')}
                            options={poOptions}
                            onChange={handlePurchaseOrderChange}
                            value={poOptions.find(option => option.value === values.commandeNumero)}
                            className="react-select"
                            classNamePrefix="select"
                            noOptionsMessage={() => t('reception.noOrderFound')}
                            loadingMessage={() => t('common.loading')}
                        />
                    </FormGroup>}
                </Col>
                <Col md="3">
                    <Label htmlFor="supplier">{t('purchase.supplier')}:</Label>
                    <Select
                        id="supplier"
                        name="supplier"
                        isClearable
                        placeholder={t('purchase.selectSupplier')}
                        options={fournisseurOptions}
                        onChange={handleSupplierChange}
                        value={fournisseurOptions.find(option => option.value === values.fournisseurId)}
                        className="react-select"
                        classNamePrefix="select"
                        noOptionsMessage={() => t('purchase.noSupplierFound')}
                        loadingMessage={() => t('common.loading')}
                        components={{
                            DropdownIndicator: () => <FaUser className="me-2" />,
                            Option: ({ children, ...props }) => (
                                <components.Option {...props}>{children}</components.Option>
                            ),
                            MenuList: ({ children, ...props }) => (
                                <components.MenuList {...props}>
                                    {children}
                                    <div className="border-top p-2">
                                        <Button
                                            color="primary"
                                            size="sm"
                                            block
                                            onClick={handleCreateSupplier}
                                        >
                                            <FaPlus className="me-1" /> {t('supplier.new')}
                                        </Button>
                                    </div>
                                </components.MenuList>
                            )
                        }}
                    />
                    {formik.touched.fournisseurId && formik.errors.fournisseurId && (
                        <div className="invalid-feedback d-block">
                            {formik.errors.fournisseurId}
                        </div>
                    )}
                </Col>
                <Col md="3">
                    <Label htmlFor="entrepotId">{t('commande.entrepot')}:</Label>
                    <Select
                        id="entrepotId"
                        options={entrepotOptions}
                        value={entrepotOptions.find(option => option.value === values.entrepotId)}
                        onChange={(selectedOption) => setFieldValue('entrepotId', selectedOption.value)}
                        placeholder={t('commande.selectEntrepot')}
                        isSearchable
                        isDisabled={values.statut === 'VALIDE' ? true : false}
                    />
                    {touched.entrepotId && formik.errors.entrepotId && (
                        <div className="text-danger small mt-1">{formik.errors.entrepotId}</div>
                    )}
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{t('reception.receiptDate')}</Label>
                        <Input
                            type="date"
                            name="dateReception"
                            {...getFieldProps('dateReception')}
                            disabled={values.statut === 'VALIDE'}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{t('reception.dateOperation')}</Label>
                        <Input
                            type="date"
                            name="dateOperation"
                            {...getFieldProps('dateOperation')}
                            disabled={values.statut === 'VALIDE'}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{t('reception.deliveryNoteNb')}</Label>
                        <Input
                            type="text"
                            name="deliveryNoteNb"
                            {...getFieldProps('deliveryNoteNb')}
                            disabled={values.statut === 'VALIDE'}
                        />
                        {formik.touched.deliveryNoteNb && formik.errors.deliveryNoteNb && (
                            <div className="invalid-feedback d-block">
                                {formik.errors.deliveryNoteNb}
                            </div>
                        )}
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <Label for="modeReglement">
                            <FaMoneyBillWave className="me-1" />
                            {t('facture.modeReglement')} *
                        </Label>
                        <Input
                            type="select"
                            id="modeReglement"
                            name="modeReglement"
                            value={values.modeReglement}
                            onChange={(e) => setFieldValue('modeReglement', e.target.value)}
                        >
                            <option value="">{t('common.select')}</option>
                            <option value="ESPECES">{t('facture.modeReglement.espece')}</option>
                            <option value="CHEQUE">{t('facture.modeReglement.cheque')}</option>
                            <option value="VIREMENT">{t('facture.modeReglement.virement')}</option>
                            <option value="CARTE_BANCAIRE">{t('facture.modeReglement.card')}</option>
                            <option value="TRAITE">{t('facture.modeReglement.traite')}</option>
                        </Input>
                    </FormGroup>
                </Col>
                {(values.modeReglement === 'CHEQUE') && (

                    <Col md={3}>
                        <FormGroup>
                            <Label for="numeroCheque">{t('reglement.numeroCheque')}</Label>
                            <Input
                                name="numeroCheque"
                                type="text"
                                className="form-control"
                                value={values.numeroCheque}
                                onChange={(e) => formik.setFieldValue('numeroCheque', e.target.value)}
                                disabled={values.statut !== 'EN_ATTENTE'}
                            />
                        </FormGroup>
                    </Col>)}
            </Row>
            <Row>
                <ReceptionLines formik={formik} />
                {formik.touched.lignes && formik.errors.lignes && (
                    <div className="invalid-feedback d-block">
                        {formik.errors.lignes}
                    </div>
                )}
            </Row>
            <Row className="mt-3 justify-content-end">
                <Col md={4}>
                    <div className="totals text-center">
                        <p><strong>{t('cart.totalHT')}:</strong> {formatPrice(values.montantTotalHT)}</p>
                        <p><strong>{t('cart.totalTVA')}:</strong> {formatPrice(values.montantTotalTaxe)}</p>
                        <p><strong>{t('cart.totalTTC')}:</strong> {formatPrice(values.montantTotalTTC)}</p>

                    </div>
                </Col>
            </Row>
            <Button type="submit" color="primary" className="me-2"
                disabled={values.statut !== 'EN_ATTENTE'}
            >
                {t('common.save')}
            </Button>
            <Button color="secondary" onClick={onClose}>{t('common.cancel')}</Button>
        </Form>
        <Modal isOpen={showSupplierModal} toggle={() => setShowSupplierModal(false)} size="xl">
            <ModalHeader toggle={() => setShowSupplierModal(false)}>
                {t('supplier.new')}
            </ModalHeader>
            <ModalBody>
                <style>
                    {`
                                            .form-floating {
                                                margin-bottom: 1rem;
                                            }
                                            .form-floating > .form-control-sm {
                                                height: calc(2.5rem + 2px);
                                                padding: 0.5rem 0.75rem;
                                                font-size: 0.875rem;
                                                border-radius: 0.375rem;
                                            }
                                            .form-floating > label {
                                                padding: 0.5rem 0.75rem;
                                                font-size: 0.875rem;
                                            }
                                            .form-control-sm {
                                                transition: all 0.2s ease-in-out;
                                            }
                                            .form-control-sm:focus {
                                                background-color: #fff !important;
                                                box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
                                                border-color: #86b7fe !important;
                                            }
                                            .fournisseur-type-buttons {
                                                display: inline-flex;
                                                background: #f8f9fa;
                                                padding: 0.25rem;
                                                border-radius: 0.5rem;
                                                gap: 0.25rem;
                                                margin-bottom: 1.5rem;
                                            }
                                            .fournisseur-type-btn {
                                                border: none;
                                                background: transparent;
                                                padding: 0.5rem 1rem;
                                                border-radius: 0.375rem;
                                                display: flex;
                                                align-items: center;
                                                gap: 0.5rem;
                                                font-size: 0.875rem;
                                                color: #6c757d;
                                                transition: all 0.2s;
                                            }
                                            .fournisseur-type-btn.active {
                                                background: white;
                                                color: #0d6efd;
                                                box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                                            }
                                            .fournisseur-type-btn:hover:not(.active) {
                                                background: rgba(255,255,255,0.5);
                                            }
                                            .required-field::after {
                                                content: ' *';
                                                color: #dc3545;
                                            }
                                            .g-3 {
                                                --bs-gutter-y: 1rem;
                                            }
                                        `}
                </style>
                <div className="fournisseur-type-toggle">
                    <div className="fournisseur-type-buttons">
                        <button
                            type="button"
                            className={`fournisseur-type-btn ${fournisseur.typeFournisseur === 'PARTICULIER' ? 'active' : ''}`}
                            onClick={() => handleFournisseurChange({ target: { name: 'typeFournisseur', value: 'PARTICULIER' } })}
                        >
                            <FaUser />
                            Particulier
                        </button>
                        <button
                            type="button"
                            className={`fournisseur-type-btn ${fournisseur.typeFournisseur === 'ENTREPRISE' ? 'active' : ''}`}
                            onClick={() => handleFournisseurChange({ target: { name: 'typeFournisseur', value: 'ENTREPRISE' } })}
                        >
                            <FaBuilding />
                            Entreprise
                        </button>
                    </div>
                </div>

                {/* Particulier Fields */}
                {fournisseur.typeFournisseur === 'PARTICULIER' && (
                    <Row className="fournisseur-form-row">
                        <Col md={4}>
                            <FormGroup className="fournisseur-form-group">
                                <Label for="nom" className="fournisseur-form-label required-field">
                                    <FaUser />
                                    Nom
                                </Label>
                                <Input
                                    type="text"
                                    id="nom"
                                    name="nom"
                                    value={fournisseur.nom}
                                    onChange={handleFournisseurChange}
                                    className={`fournisseur-form-input ${errors.nom ? 'is-invalid' : ''}`}
                                    placeholder="El Fassi"
                                />
                                {errors.nom && <div className="fournisseur-form-error">{errors.nom}</div>}
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup className="fournisseur-form-group">
                                <Label for="prenom" className="fournisseur-form-label required-field">
                                    <FaUser />
                                    Prénom
                                </Label>
                                <Input
                                    type="text"
                                    id="prenom"
                                    name="prenom"
                                    value={fournisseur.prenom}
                                    onChange={handleFournisseurChange}
                                    className={`fournisseur-form-input ${errors.prenom ? 'is-invalid' : ''}`}
                                    placeholder="Karim"
                                />
                                {errors.prenom && <div className="fournisseur-form-error">{errors.prenom}</div>}
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup className="fournisseur-form-group">
                                <Label for="cin" className="fournisseur-form-label">
                                    <FaIdCard />
                                    CIN
                                </Label>
                                <Input
                                    type="text"
                                    id="cin"
                                    name="cin"
                                    value={fournisseur.cin}
                                    onChange={handleFournisseurChange}
                                    className="fournisseur-form-input"
                                    placeholder="AB123456"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                )}
                {/* Entreprise Fields */}
                {fournisseur.typeFournisseur === 'ENTREPRISE' && (
                    <Row className="fournisseur-form-row">
                        <Col md={6}>
                            <FormGroup className="fournisseur-form-group">
                                <Label for="entreprise" className="fournisseur-form-label required-field">
                                    <FaBuilding />
                                    Nom de l'entreprise
                                </Label>
                                <Input
                                    type="text"
                                    id="entreprise"
                                    name="entreprise"
                                    value={fournisseur.entreprise}
                                    onChange={handleFournisseurChange}
                                    className={`fournisseur-form-input ${errors.entreprise ? 'is-invalid' : ''}`}
                                    placeholder="Nom de l'entreprise"
                                />
                                {errors.entreprise && <div className="fournisseur-form-error">{errors.entreprise}</div>}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup className="fournisseur-form-group">
                                <Label for="ice" className="fournisseur-form-label required-field">
                                    <FaIdCard />
                                    Numéro ICE
                                </Label>
                                <Input
                                    type="text"
                                    id="ice"
                                    name="ice"
                                    value={fournisseur.ice}
                                    onChange={handleFournisseurChange}
                                    className={`fournisseur-form-input ${errors.ice ? 'is-invalid' : ''}`}
                                    placeholder="000123456789012"
                                />
                                {errors.ice && <div className="fournisseur-form-error">{errors.ice}</div>}
                            </FormGroup>
                        </Col>
                    </Row>
                )}
                <Row className="g-3">
                    <Col md={3}>
                        <FormGroup>
                            <Label for="telephone1">
                                <FaPhone className="me-2" size={12} />
                                Téléphone (1) *
                            </Label>
                            <Input
                                type="tel"
                                id="telephone1"
                                name="telephone1"
                                value={fournisseur.telephone1}
                                onChange={handleFournisseurChange}
                                invalid={!!errors.telephone1}
                                placeholder="06 12 34 56 78"
                                className="py-2"
                            />

                            {errors.telephone1 && <div className="text-danger small mt-1">{errors.telephone1}</div>}
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label for="telephone2">
                                <FaPhone className="me-2" size={12} />
                                Téléphone (2) *
                            </Label>
                            <Input
                                type="tel"
                                id="telephone2"
                                name="telephone2"
                                value={fournisseur.telephone2}
                                onChange={handleFournisseurChange}
                                invalid={!!errors.telephone2}
                                placeholder="06 12 34 56 78"
                                className="py-2"
                            />

                            {errors.telephone2 && <div className="text-danger small mt-1">{errors.telephone2}</div>}
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label for="email" lassName="fw-bold">
                                <FaEnvelope className="me-2" size={12} />
                                Email
                            </Label>
                            <Input
                                type="email"
                                id="email"
                                name="email"
                                value={fournisseur.email}
                                onChange={handleFournisseurChange}
                                placeholder="k.elfassi@example.com"
                                className="py-2"
                            />

                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup className="mb-4">
                            <Label for="ville" className="fw-bold">
                                <FaMapMarkerAlt className="me-2 text-muted" />
                                Ville
                            </Label>
                            <Input
                                type="select"
                                id="ville"
                                name="ville"
                                value={fournisseur.ville}
                                onChange={handleFournisseurChange}
                                className="py-2"
                            >
                                {villesMaroc.map(ville => (
                                    <option key={ville} value={ville}>{ville}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>

                </Row>
                <Row>
                    <Col md={8}>
                        <FormGroup className="mb-4">
                            <Label for="adresse" className="fw-bold">
                                <FaMapMarkerAlt className="me-2 text-muted" />
                                Adresse*
                            </Label>
                            <Input
                                type="textarea"
                                rows="2"
                                id="adresse"
                                name="adresse"
                                value={fournisseur.adresse}
                                onChange={handleFournisseurChange}
                                placeholder="12 Rue Moulay Rachid"
                                className="py-2"
                            />
                            {errors.adresse && <div className="text-danger small mt-1">{errors.adresse}</div>}
                        </FormGroup>
                    </Col>


                    <Col md={3}>
                        <FormGroup className="mb-4">
                            <Label for="active" className="fw-bold">
                                <FaBusinessTime className="me-2 text-muted" />
                                Statut Actif*
                            </Label>
                            <Input
                                type="select"
                                id="active"
                                name="active"
                                value={fournisseur.active.toString()} // Convert boolean to string for the select element
                                onChange={handleFournisseurChange}
                                className="py-2"
                            >
                                <option value="true">Actif</option>
                                <option value="false">Inactif</option>
                            </Input>
                        </FormGroup>
                    </Col>

                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSupplierSubmit}>
                    {t('common.save')}
                </Button>
                <Button color="secondary" onClick={() => setShowSupplierModal(false)}>
                    {t('common.cancel')}
                </Button>
            </ModalFooter>
        </Modal>
    </>
    );
};

export default ReceiptNoteNew;